import el from "@cypherpotato/el";

export function ColorPickerControl(value, ...args) {

    const selectedValue = el.state.create(value);

    return el.state.listening([selectedValue], () =>
        el("label.color-picker-wrapper",
            {
                $properties: {
                    value: {
                        get() {
                            return selectedValue.value;
                        },
                        set(value) {
                            selectedValue.value = value;
                        }
                    }
                }
            },
            el("input",
                {
                    type: "color",
                    value: selectedValue.value,
                    onChange(event) {
                        selectedValue.value = event.target.value;
                    }
                }
            ),
            el("div",
                {
                    style: {
                        backgroundColor: selectedValue.value
                    }
                }
            ),
            ...args
        )
    );
}